import React from "react";
import Herosec from "../pagesections/Herosec";
import Counter from "../counter/Counter";
import Searchjob from "../pagesections/Serchjob";
import Expertsec from "../pagesections/Expertsec";
import Programsec from "../pagesections/Programsec";
import Featuredcompany from "../pagesections/Featuredcompany";
import Footer from "../pagesections/Footer";
import Testimonials from "../../containers/testimonials/Testimonials";
import "./appfooter.css";
import Recgnsdcomp from "../banners/Recgnsdcomp";

function Landing() {
  return (
    <div className="landing-page-container">
      <Herosec />
      <div className="srch-job-banner-landing">
        <Recgnsdcomp />
      </div>
      <Counter />
      <Searchjob />
      <Expertsec />
      <Programsec />
      <Featuredcompany />
      <Testimonials />
      <div className="footer-container-landing">
        <Footer />
      </div>
    </div>
  );
}

export default Landing;
